export default {
	MOVE_LEFT: "MOVE_LEFT",
	MOVE_RIGHT: "MOVE_RIGHT",
	MOVE_UP: "MOVE_UP",
	MOVE_DOWN: "MOVE_DOWN",
	UNDO: "UNDO"
}



// WEBPACK FOOTER //
// ./src/actionCreators/playerActionNames.js